import script from "./insurance-criteria-form.vue?vue&type=script&setup=true&lang=js"
export * from "./insurance-criteria-form.vue?vue&type=script&setup=true&lang=js"

import "./insurance-criteria-form.vue?vue&type=style&index=0&id=e7a524bc&scoped=true&lang=css"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7a524bc"]])

export default __exports__